<div>
	<gb-ui-page-heading [titleText]="pageTitle" bannerType="success">
		<ng-template #subContent>
			<div class="sub-content">
				<p>{{ 'CONFIRMATION.REFERENCE_TEXT' | translate }}</p>
				<p class="h1">
					{{ bookingNumber }}
				</p>
			</div>
		</ng-template>
	</gb-ui-page-heading>
	<div class="govuk-width-container">
		<div class="govuk-grid-row m-0">
			<h2 *ngIf="datastoreService.pageContent.confirmation_page_subtitle" id="main-content" tabindex="-1">
				{{ datastoreService.pageContent.confirmation_page_subtitle }}
			</h2>
			<p [innerHTML]="
					datastoreService.pageContent.confirmation_page_subtitle_body
				"></p>

			@if (agentMode) {
			<button type="button" class="govuk-button govuk-button--inverse heading-button" data-module="govuk-button"
				(click)="datastoreService?.agentRestart()">
				Agent Restart
			</button>
			}

			<ng-template #locationAddress>
				<p>
					@if (selectedLocation.address.address1) {
					{{ selectedLocation.address.address1 }}<br />
					} @if (selectedLocation.address.address2) {
					{{ selectedLocation.address.address2 }}<br />
					} @if (selectedLocation.address.address3) {
					{{ selectedLocation.address.address3 }}<br />
					} @if (selectedLocation.address.address4) {
					{{ selectedLocation.address.address4 }}<br />
					} @if (selectedLocation.address.postcode) {
					{{ selectedLocation.address.postcode }}<br />
					} @if (selectedLocation.address.country) {
					{{ selectedLocation.address.country }} }
				</p>
			</ng-template>

			@if(selectedService.global_id === 48320) {
			<p>For your reference, the following confirmation has been sent to the main contact email address you provided.</p>
			<p>Thank you for booking a birth registration appointment on:<br>
				{{
				selectedSlot?.start
				| date : 'EEEE d MMMM yyyy' : '' : translateService.currentLang
				}}
				at {{ selectedSlot?.displayTime }}
			</p>
			<p>At:</p>
			@if (datastoreService?.booking?.resource_name.includes('(AC)')) {
			<p>Norwich Registration Office (AC)<br>County Hall (Archive Centre)<br>Martineau Lane<br>Norwich<br>NR1 2DQ</p>
			} @else if (datastoreService?.booking?.resource_name.includes('(CH)')) {
			<p>Norwich Registration Office (CH)<br>County Hall (Main Building)<br>Martineau Lane<br>Norwich<br>NR1 2DQ</p>
			} @else {
			<p>{{ selectedLocation.name }}</p>
			<ng-container *ngTemplateOutlet="locationAddress"></ng-container>
			}

			<h2>Please read the important information below</h2>
			<p>For details of the Registration Office, including a map, visit <a href="https://www.norfolk.gov.uk/42539" target="_blank" rel="noopener noreferrer">Registration offices in Norfolk - Norfolk County Council<span class="govuk-visually-hidden"> (opens in new tab)</span></a></p>
			<p>Please make sure you arrive on time for your appointment. If you arrive late, we may not be able to keep your appointment, and you will have to rearrange. Thank you for understanding.</p>
			<p>Pets are not allowed but assistance dogs are welcome.</p>
			<p>Under the Perjury Act 1911, knowingly giving a registrar false information for inclusion in a registration is an offence and may result in prosecution.</p>
			<p>We are happy for you to bring your baby to the appointment, but you do not have to.</p>

			<h2>Before attending</h2>
			<p>Please make sure you:</p>
			<ul>
				<li>Have agreed on your child′s full name and spellings</li>
				<li>Know the occupation and place of birth (town or city) of baby′s parents</li>
			</ul>

			<h2>Documents to bring</h2>
			<p>From 9 November 2026, changes to the law mean you will need to bring proof of identity with you to your appointment. If you do not bring proof of identity, we will not be able to register your child.</p>
			<p>There are many documents that can be used as proof of identity. Please see our <a href="https://www.norfolk.gov.uk/article/81935/Acceptable-proof-of-identity-list---birth-registrations" target="_blank" rel="noopener noreferrer"><strong>list of accepted proof of identity documents</strong><span class="govuk-visually-hidden"> (opens in new tab)</span></a> before your appointment.</p>
			<p>If possible, please also bring to the appointment either:</p>
			<ul>
				<li>The Notification of Birth that you were given at the hospital</li>
				<li>The Red Book giving us your child's NHS number</li>
			</ul>
			<p>You will be asked to check the information before the registration is completed. Once the registration has been completed, there may be a charge to correct any errors.</p>

			<h2>Certificates and payment</h2>
			<p>If you have paid for any certificates in advance, you can collect these at your appointment after the registration has been completed.</p>
			<p>If you are paying for certificates at your appointment, we only accept debit/credit cards and smart device contactless payments. We do not accept payments from American Express. Certificates cost £12.50 each.</p>

			<h2>Cancellations or rearranging your appointment</h2>
			<p>If you need to cancel or reschedule before the day of your appointment, please use the unique link in your confirmation email.</p>
			<h2>On the day of the appointment</h2>
			<p>If you need to cancel or rearrange on the day of your appointment, please contact us on 01603 306149.</p>
			<p>If you have an appointment on a Saturday which you need to cancel or rearrange on the day, please email <a href="mailto:cancelappointment&#64;norfolk.gov.uk">cancelappointment&#64;norfolk.gov.uk</a>.</p>
			<p>We look forward to welcoming you.</p>

			} @else if (selectedService.global_id === 48350) {
			<p>For your reference, the following confirmation has been sent to the main contact email address you provided.</p>
			<p>Thank you for booking a birth registration declaration appointment on:<br>
				{{
				selectedSlot?.start
				| date : 'EEEE d MMMM yyyy' : '' : translateService.currentLang
				}}
				at {{ selectedSlot?.displayTime }}
			</p>
			<p>At:</p>
			@if (datastoreService?.booking?.resource_name.includes('(AC)')) {
			<p>Norwich Registration Office (AC)<br>County Hall (Archive Centre)<br>Martineau Lane<br>Norwich<br>NR1 2DQ</p>
			} @else if (datastoreService?.booking?.resource_name.includes('(CH)')) {
			<p>Norwich Registration Office (CH)<br>County Hall (Main Building)<br>Martineau Lane<br>Norwich<br>NR1 2DQ</p>
			} @else {
			<p>{{ selectedLocation.name }}</p>
			<ng-container *ngTemplateOutlet="locationAddress"></ng-container>
			}

			<h2>Please read the important information below</h2>
			<p>For details of the Registration Office, including a map, visit <a href="https://www.norfolk.gov.uk/42539" target="_blank" rel="noopener noreferrer">Registration offices in Norfolk - Norfolk County Council<span class="govuk-visually-hidden"> (opens in new tab)</span></a></p>
			<p>Please make sure you arrive on time for your appointment. If you arrive late, we may not be able to keep your appointment, and you will have to rearrange. Thank you for understanding.</p>
			<p>Pets are not allowed but assistance dogs are welcome.</p>
			<p>Under the Perjury Act 1911, knowingly giving a registrar false information for inclusion in a registration is an offence and may result in prosecution.</p>
			<p>We are happy for you to bring your baby to the appointment, but you do not have to.</p>

			<h2>Before attending</h2>
			<p>Please make sure you:</p>
			<ul>
				<li>Have agreed on your child′s full name and spellings</li>
				<li>Know the occupation and place of birth (town or city) of baby′s parents</li>
			</ul>

			<h2>Documents to bring</h2>
			<p>Please bring to the appointment either:</p>
			<ul>
				<li>The Notification of Birth that you were given at the hospital</li>
				<li>The Red Book giving us your child's NHS number</li>
			</ul>
			<p>To make sure we record the correct details we recommend you bring a document which shows the parent(s)' names, such as:</p>
			<ul>
				<li>Driving licence</li>
				<li>Passport</li>
				<li>Birth certificate</li>
			</ul>
			<p>You do not have to bring any of these documents to the appointment, but it helps us to avoid any errors.</p>
			<p>You will be asked to check the information before the registration is completed. Once the registration has been completed, there may be a charge to correct any errors.</p>

			<h2>Certificates and payment</h2>
			<p>After your appointment:</p>
			<ul>
				<li>We will not be able to produce any certificates</li>
				<li>We will email your signed declaration to the register office in the district where the birth took place</li>
				<li>The district where the birth took place will then register the birth</li>
				<li>Certificates are £12.50 each and your payment will need to be made to the register office in the district where the birth took place</li>
				<li>You can find the contact details for the register office where the birth took place by visiting <a href="https://www.gov.uk/register-offices" target="_blank" rel="noopener noreferrer">Find a register office - GOV.UK<span class="govuk-visually-hidden"> (opens in new tab)</span></a></li>
			</ul>

			<h2>Cancellations or rearranging your appointment</h2>
			<p>If you need to cancel or reschedule before the day of your appointment, please use the unique link in your confirmation email.</p>
			<h2>On the day of the appointment</h2>
			<p>If you need to cancel or rearrange on the day of your appointment, please contact us on 01603 306149.</p>
			<p>If you have an appointment on a Saturday which you need to cancel or rearrange on the day, please email <a href="mailto:cancelappointment&#64;norfolk.gov.uk">cancelappointment&#64;norfolk.gov.uk</a>.</p>
			<p>We look forward to welcoming you.</p>

			} @else if (datastoreService?.booking?.company_id == 37020 || selectedLocation?.id == 37020) {
			<p>For your reference, the following confirmation has been sent to the main contact email address you provided.</p>
			<p>We can confirm that you have booked an appointment to register a death over the phone on:<br>
				{{
				selectedSlot?.start
				| date : 'EEEE d MMMM yyyy' : '' : translateService.currentLang
				}}
				at {{ selectedSlot?.displayTime }}
			</p>

			<h2>Please read the important information below</h2>
			<p>Please make sure you are ready to answer the phone at the time of your appointment. If you are late, we may not be able to keep your appointment, and you will have to rearrange. Thank you for understanding.</p>
			<p>Under the Perjury Act 1911, knowingly giving a registrar false information for inclusion in a registration is an offence and may result in prosecution.</p>

			<h2>Before your appointment</h2>
			<p>The registration cannot be completed without the necessary medical paperwork from the Medical Examiner's Office or Coroner. If this paperwork is not received, we will contact you to rearrange your appointment.</p>

			<h2>Information to have ready</h2>
			<p>The information you provide the registrar must be true and accurate to the best of your knowledge. To help avoid mistakes, please have documents available that show the details of the deceased.</p>
			<p>Examples of these documents may be:</p>
			<ul>
				<li>Passport</li>
				<li>Driving licence</li>
				<li>Birth certificate</li>
				<li>Deed poll or change of name deed document</li>
				<li>Marriage or civil partnership certificate</li>
				<li>Council tax bill or recent utility bill</li>
			</ul>
			<p>You do not have to have any of these documents during the appointment, but it helps us to avoid any errors.</p>
			<p>For a full list of the information you′ll need to provide please visit <a href="https://www.norfolk.gov.uk/article/42548/Register-a-death" target="_blank" rel="noopener noreferrer">Register a death - Norfolk County Council<span class="govuk-visually-hidden"> (opens in new tab)</span></a>.</p>
			<p>You will be asked to check the information before the registration is completed. Once the registration has been completed, there may be a charge to correct any errors.</p>

			<h2>Documents issued</h2>
			<h3>Funeral Director Paperwork</h3>
			<p>During your appointment, the registrar will complete the paperwork that the funeral director needs. If you can tell us which funeral director you are using, we will email the paperwork straight to them.</p>
			<h3>Tell Us Once Service</h3>
			<p>If you want to use the free <a href="https://www.gov.uk/after-a-death/organisations-you-need-to-contact-and-tell-us-once" target="_blank" rel="noopener noreferrer">Tell Us Once<span class="govuk-visually-hidden"> (opens in new tab)</span></a> service:</p>
			<ul>
				<li>You will be given a unique reference number at the appointment.</li>
				<li>You can then use this number, after the appointment, to complete Tell Us Once online or by phone.</li>
				<li>The registrar will explain how Tell Us Once works at the appointment.</li>
			</ul>

			<h2>Certificates and payment</h2>
			<p>If you have paid for any certificates in advance, these will be sent to you by first-class post after the appointment.</p>
			<p>If you need to order certificates you can do this online at <a href="https://www.norfolk.gov.uk/article/42538/Copy-certificates" target="_blank" rel="noopener noreferrer">Copy certificates - Norfolk County Council<span class="govuk-visually-hidden"> (opens in new tab)</span></a> or by phoning 01603 306149 <strong>after the appointment</strong>. The registrar will not be able to take the payment for certificates during the registration appointment.</p>

			<h2>Cancellations or rearranging your appointment</h2>
			<p>If you need to cancel or reschedule before the day of your appointment, please use the unique link in your confirmation email.</p>
			<h2>On the day of the appointment</h2>
			<p>If you need to cancel or rearrange on the day of your appointment, please contact us on 01603 306149.</p>
			<p>If you have an appointment on a Saturday which you need to cancel or rearrange on the day, please email <a href="mailto:cancelappointment&#64;norfolk.gov.uk">cancelappointment&#64;norfolk.gov.uk</a>.</p>

			} @else if (selectedService.global_id === 48335) {
			<p>For your reference, the following confirmation has been sent to the main contact email address you provided.</p>
			<p>We can confirm that you have booked an appointment to register a death on:<br>
				{{
				selectedSlot?.start
				| date : 'EEEE d MMMM yyyy' : '' : translateService.currentLang
				}}
				at {{ selectedSlot?.displayTime }}
			</p>
			<p>At:</p>
			@if (datastoreService?.booking?.resource_name.includes('(AC)')) {
			<p>Norwich Registration Office (AC)<br>County Hall (Archive Centre)<br>Martineau Lane<br>Norwich<br>NR1 2DQ</p>
			} @else if (datastoreService?.booking?.resource_name.includes('(CH)')) {
			<p>Norwich Registration Office (CH)<br>County Hall (Main Building)<br>Martineau Lane<br>Norwich<br>NR1 2DQ</p>
			} @else {
			<p>{{ selectedLocation.name }}</p>
			<ng-container *ngTemplateOutlet="locationAddress"></ng-container>
			}

			<h2>Please read the important information below</h2>
			<p>For details of the Registration Office, including a map, visit <a href="https://www.norfolk.gov.uk/42539" target="_blank" rel="noopener noreferrer">Registration offices in Norfolk - Norfolk County Council<span class="govuk-visually-hidden"> (opens in new tab)</span></a></p>
			<p>Please make sure you arrive on time for your appointment. If you arrive late, we may not be able to keep your appointment, and you will have to rearrange. Thank you for understanding.</p>
			<p>Under the Perjury Act 1911, knowingly giving a registrar false information for inclusion in a registration is an offence and may result in prosecution.</p>
			<p>Pets are not allowed but assistance dogs are welcome.</p>

			<h2>Before attending</h2>
			<p>The registration cannot be completed without the necessary medical paperwork from the Medical Examiner's Office or Coroner. If this paperwork is not received, we will contact you to rearrange your appointment.</p>

			<h2>Documents to bring</h2>
			<p>The information you provide the registrar must be true and accurate to the best of your knowledge. To help avoid mistakes, please bring documents that show the details of the deceased.</p>
			<p>Examples of these documents may be:</p>
			<ul>
				<li>Passport</li>
				<li>Driving licence</li>
				<li>Birth certificate</li>
				<li>Deed poll or change of name deed document</li>
				<li>Marriage or civil partnership certificate</li>
				<li>Council tax bill or recent utility bill</li>
			</ul>
			<p>We also recommend that the person registering the death brings a document that shows their own name and address, such as a driving licence.</p>
			<p>You do not have to bring any of these documents to the appointment, but it helps us to avoid any errors.</p>
			<p>For a full list of the information you′ll need to provide please visit <a href="https://www.norfolk.gov.uk/article/42548/Register-a-death" target="_blank" rel="noopener noreferrer">Register a death - Norfolk County Council<span class="govuk-visually-hidden"> (opens in new tab)</span></a>.</p>
			<p>You will be asked to check the information before the registration is completed. Once the registration has been completed, there may be a charge to correct any errors.</p>

			<h2>Documents issued</h2>
			<h3>Funeral Director paperwork</h3>
			<p>During your appointment, the registrar will complete the paperwork that the funeral director needs. If you can tell us which funeral director you are using, we will email the paperwork straight to them.</p>
			<h3>Tell Us Once service</h3>
			<p>If you want to use the free <a href="https://www.gov.uk/after-a-death/organisations-you-need-to-contact-and-tell-us-once" target="_blank" rel="noopener noreferrer">Tell Us Once<span class="govuk-visually-hidden"> (opens in new tab)</span></a> service:</p>
			<ul>
				<li>You will be given a unique reference number at the appointment.</li>
				<li>You can then use this number, after the appointment, to complete Tell Us Once online or by phone.</li>
				<li>The registrar will explain how Tell Us Once works at the appointment.</li>
			</ul>

			<h2>Certificates and payment</h2>
			<p>If you have paid for any certificates in advance, you can collect these at your appointment after the registration has been completed.</p>
			<p>If you are paying for certificates at your appointment, we only accept debit/credit cards and smart device contactless payments. We do not accept payments from American Express. Certificates cost £12.50 each.</p>

			<h2>Cancellations or rearranging your appointment</h2>
			<p>If you need to cancel or reschedule before the day of your appointment, please use the unique link in your confirmation email.</p>
			<h2>On the day of the appointment</h2>
			<p>If you need to cancel or rearrange on the day of your appointment, please contact us on 01603 306149.</p>
			<p>If you have an appointment on a Saturday which you need to cancel or rearrange on the day, please email <a href="mailto:cancelappointment&#64;norfolk.gov.uk">cancelappointment&#64;norfolk.gov.uk</a>.</p>

			} @else if (selectedService.global_id === 48400) {
			<p>
	For your reference, the following confirmation has been sent to the main contact email address you provided.
</p>

<p>
	This confirms that you have booked an appointment to give notice of marriage or civil partnership on:<br>
	{{
	selectedSlot?.start
	| date : 'EEEE d MMMM yyyy' : '' : translateService.currentLang
	}}
	at {{ selectedSlot?.displayTime }}
</p>
@if (datastoreService?.booking?.resource_name.includes('(AC)')) {
<p>At: County Hall (Archive Centre)<br>Martineau Lane<br>Norwich<br>NR1 2DQ</p>
} @else if (datastoreService?.booking?.resource_name.includes('(CH)')) {
<p>At: County Hall<br>Martineau Lane<br>Norwich<br>NR1 2DQ</p>
} @else {
<p>At: {{ selectedLocation.name }}</p>
<ng-container *ngTemplateOutlet="locationAddress"></ng-container>
}

<h2>Please read the important information below</h2>
<p>
	For details of the Registration Office, including a map, please visit
	<a href="https://www.norfolk.gov.uk/article/42539/Registration-offices-in-Norfolk"
		target="_blank">Registration offices in Norfolk - Norfolk County Council<span
			class="govuk-visually-hidden"> (opens in new tab)</span></a>
</p>
<p>
	Please make sure you arrive on time for your appointment. If you arrive late, we may not be able to keep your
	appointment, and you will have to rearrange. Thank you for understanding.
</p>
<p>No pets are allowed but assistance dogs are very welcome.</p>

<p>
	Your Notice is venue-specific. You will need to know the full name and address of your ceremony venue before
	your notice appointment.
</p>

<p>
	Giving notice is not the same as booking the venue. If you have not booked the venue, or registrars to attend
	your ceremony, please do so.
</p>

<h2>Documents to bring</h2>
<p>
	You and your partner must bring certain original documents (not photocopies) to your notice appointment, as
	required by law.
</p>
<p>
	If you don't bring the right documents, we won't be able to take your notice, so please take the time to check
	what you need and gather everything in advance.
</p>
<p>
	<a href="https://www.norfolk.gov.uk/article/76740/Documents-to-bring-when-giving-notice"
		target="_blank" rel="noopener noreferrer">Check what documents to bring when giving notice<span
			class="govuk-visually-hidden"> (opens in new tab)</span></a>
</p>

<h2>Payment</h2>
<p>
	The standard notice fee is £46.50 per person, you will need to pay at your appointment.
</p>
<p>Additional fees may apply in certain circumstances:</p>
<ul>
	<li>
		<strong>Home Office Referral:</strong> If either of you needs to be referred to the Home Office, there is an
		additional fee of £16.50 each, which you will pay at your appointment which you attend together. If this
		applies to you, or if you or your partner have marriage visas, you will both need to bring printed
		passport-sized photographs. To find out if you will be subject to a Home Office referral, or you need passport
		photos, please visit
		<a href="https://www.norfolk.gov.uk/article/76740/Documents-to-bring-when-giving-notice"
			target="_blank" rel="noopener noreferrer">Documents to bring when giving notice - Norfolk County
			Council<span class="govuk-visually-hidden"> (opens in new tab)</span></a>.
	</li>
	<li>
		<strong>Foreign Divorce Documents:</strong> If either of you was divorced outside the British Isles, you'll
		need to pay a non-refundable fee for checking the foreign divorce paperwork. The fee is charged per divorce
		rather than per couple. The fees are:
		<ul>
			<li>£55 if the documents can be checked locally</li>
			<li>£83 if the documents need to be referred to the General Register Office (GRO)</li>
			<li>
				You can find more details about what documents to bring and how much you may need to pay by visiting
				<a href="https://www.norfolk.gov.uk/article/76740/Documents-to-bring-when-giving-notice"
					target="_blank" rel="noopener noreferrer">Documents to bring when giving notice - Norfolk County
					Council<span class="govuk-visually-hidden"> (opens in new tab)</span></a>
			</li>
		</ul>
	</li>
</ul>
<p>
	Any additional fees will be taken at your appointment. We only accept debit/credit cards and smart device
	contactless payments. We do not accept payments from American Express.
</p>

<h2>Cancelling or rearranging your appointment</h2>
<h3>Before the day of the appointment</h3>
<p>
	If you need to cancel or rearrange before the day of your appointment, please use the unique link in your
	confirmation email.
</p>
      <p>
        The link lets you change the time or date of your appointment within the same office. If you wish to rearrange your appointment to a different office location, please contact us on 01603 306149. Any pre-paid certificates will transfer to your new booking.
      </p>

<h3>On the day of the appointment</h3>
<p>
	If you need to cancel or rearrange on the day of your appointment, please contact us on 01603 306149.
</p>
<p>
	If you have a Saturday appointment which you need to cancel on the day, please email
	<a href="mailto:cancelappointment&#64;norfolk.gov.uk">cancelappointment&#64;norfolk.gov.uk</a>.
</p>
<p>Kind regards</p>
			} @else if (selectedService.global_id === 48400) {
			<p>
	For your reference, the following confirmation has been sent to the main contact email address you provided.
</p>

<p>
	This confirms that you have booked an appointment to give notice of marriage or civil partnership on:<br>
	{{
	selectedSlot?.start
	| date : 'EEEE d MMMM yyyy' : '' : translateService.currentLang
	}}
	at {{ selectedSlot?.displayTime }}
</p>
@if (datastoreService?.booking?.resource_name.includes('(AC)')) {
<p>At: County Hall (Archive Centre)<br>Martineau Lane<br>Norwich<br>NR1 2DQ</p>
} @else if (datastoreService?.booking?.resource_name.includes('(CH)')) {
<p>At: County Hall<br>Martineau Lane<br>Norwich<br>NR1 2DQ</p>
} @else {
<p>At: {{ selectedLocation.name }}</p>
<ng-container *ngTemplateOutlet="locationAddress"></ng-container>
}

<h2>Please read the important information below</h2>
<p>
	For details of the Registration Office, including a map, please visit
	<a href="https://www.norfolk.gov.uk/article/42539/Registration-offices-in-Norfolk"
		target="_blank">Registration offices in Norfolk - Norfolk County Council<span
			class="govuk-visually-hidden"> (opens in new tab)</span></a>
</p>
<p>
	Please make sure you arrive on time for your appointment. If you arrive late, we may not be able to keep your
	appointment, and you will have to rearrange. Thank you for understanding.
</p>
<p>No pets are allowed but assistance dogs are very welcome.</p>

<p>
	Your Notice is venue-specific. You will need to know the full name and address of your ceremony venue before
	your notice appointment.
</p>

<p>
	Giving notice is not the same as booking the venue. If you have not booked the venue, or registrars to attend
	your ceremony, please do so.
</p>

<h2>Documents to bring</h2>
<p>
	You and your partner must bring certain original documents (not photocopies) to your notice appointment, as
	required by law.
</p>
<p>
	If you don't bring the right documents, we won't be able to take your notice, so please take the time to check
	what you need and gather everything in advance.
</p>
<p>
	<a href="https://www.norfolk.gov.uk/article/76740/Documents-to-bring-when-giving-notice"
		target="_blank" rel="noopener noreferrer">Check what documents to bring when giving notice<span
			class="govuk-visually-hidden"> (opens in new tab)</span></a>
</p>

<h2>Payment</h2>
<p>
	The standard notice fee is £46.50 per person, you will need to pay at your appointment.
</p>
<p>Additional fees may apply in certain circumstances:</p>
<ul>
	<li>
		<strong>Home Office Referral:</strong> If either of you needs to be referred to the Home Office, there is an
		additional fee of £16.50 each, which you will pay at your appointment which you attend together. If this
		applies to you, or if you or your partner have marriage visas, you will both need to bring printed
		passport-sized photographs. To find out if you will be subject to a Home Office referral, or you need passport
		photos, please visit
		<a href="https://www.norfolk.gov.uk/article/76740/Documents-to-bring-when-giving-notice"
			target="_blank" rel="noopener noreferrer">Documents to bring when giving notice - Norfolk County
			Council<span class="govuk-visually-hidden"> (opens in new tab)</span></a>.
	</li>
	<li>
		<strong>Foreign Divorce Documents:</strong> If either of you was divorced outside the British Isles, you'll
		need to pay a non-refundable fee for checking the foreign divorce paperwork. The fee is charged per divorce
		rather than per couple. The fees are:
		<ul>
			<li>£55 if the documents can be checked locally</li>
			<li>£83 if the documents need to be referred to the General Register Office (GRO)</li>
			<li>
				You can find more details about what documents to bring and how much you may need to pay by visiting
				<a href="https://www.norfolk.gov.uk/article/76740/Documents-to-bring-when-giving-notice"
					target="_blank" rel="noopener noreferrer">Documents to bring when giving notice - Norfolk County
					Council<span class="govuk-visually-hidden"> (opens in new tab)</span></a>
			</li>
		</ul>
	</li>
</ul>
<p>
	Any additional fees will be taken at your appointment. We only accept debit/credit cards and smart device
	contactless payments. We do not accept payments from American Express.
</p>

<h2>Cancelling or rearranging your appointment</h2>
<h3>Before the day of the appointment</h3>
<p>
	If you need to cancel or rearrange before the day of your appointment, please use the unique link in your
	confirmation email.
</p>

<p>
  The link lets you change the time or date of your appointment within the same office. If you wish to rearrange your appointment to a different office location, please contact us on 01603 306149. Any pre-paid certificates will transfer to your new booking.
</p>

<h3>On the day of the appointment</h3>
<p>
	If you need to cancel or rearrange on the day of your appointment, please contact us on 01603 306149.
</p>
<p>
	If you have a Saturday appointment which you need to cancel on the day, please email
	<a href="mailto:cancelappointment&#64;norfolk.gov.uk">cancelappointment&#64;norfolk.gov.uk</a>.
</p>
<p>Kind regards</p>
			} @else if (selectedService.global_id === 48365) {
			<p>For your reference, the following confirmation has been sent to the main contact email address you provided.</p>
			<p>We can confirm that you have booked an appointment to register a death by declaration on:<br>
				{{
				selectedSlot?.start
				| date : 'EEEE d MMMM yyyy' : '' : translateService.currentLang
				}}
				at {{ selectedSlot?.displayTime }}
			</p>
			<p>At:</p>
			@if (datastoreService?.booking?.resource_name.includes('(AC)')) {
			<p>Norwich Registration Office (AC)<br>County Hall (Archive Centre)<br>Martineau Lane<br>Norwich<br>NR1 2DQ</p>
			} @else if (datastoreService?.booking?.resource_name.includes('(CH)')) {
			<p>Norwich Registration Office (CH)<br>County Hall (Main Building)<br>Martineau Lane<br>Norwich<br>NR1 2DQ</p>
			} @else {
			<p>{{ selectedLocation.name }}</p>
			<ng-container *ngTemplateOutlet="locationAddress"></ng-container>
			}

			<h2>Please read the important information below</h2>
			<p>For details of the Registration Office, including a map, visit <a href="https://www.norfolk.gov.uk/42539" target="_blank" rel="noopener noreferrer">Registration offices in Norfolk - Norfolk County Council<span class="govuk-visually-hidden"> (opens in new tab)</span></a></p>
			<p>Please make sure you arrive on time for your appointment. If you arrive late, we may not be able to keep your appointment, and you will have to rearrange. Thank you for understanding.</p>
			<p>Under the Perjury Act 1911, knowingly giving a registrar false information for inclusion in a registration is an offence and may result in prosecution.</p>
			<p>Pets are not allowed but assistance dogs are welcome.</p>

			<h2>Before attending</h2>
			<p>You will need to contact the register office in the district where the death occurred to:</p>
			<ul>
				<li>Make sure that they have the Medical Certificate of Cause of Death (MCCD) or paperwork from the Coroner's Office</li>
				<li>Ask for this paperwork to be emailed to us at <a href="mailto:mccds.registrars&#64;norfolk.gov.uk">mccds.registrars&#64;norfolk.gov.uk</a>, before your appointment.</li>
			</ul>
			<p>If this paperwork is not received, we will contact you to rearrange your appointment.</p>
			<p>You can find the contact details for the register office where the death took place by visiting <a href="https://www.gov.uk/register-offices" target="_blank" rel="noopener noreferrer">Find a register office - GOV.UK<span class="govuk-visually-hidden"> (opens in new tab)</span></a>.</p>

			<h2>Documents to bring</h2>
			<p>The information you provide the registrar must be true and accurate to the best of your knowledge. To help avoid mistakes, please bring documents that show the details of the deceased.</p>
			<p>Examples of these documents may be:</p>
			<ul>
				<li>Passport</li>
				<li>Driving licence</li>
				<li>Birth certificate</li>
				<li>Deed poll or change of name deed document</li>
				<li>Marriage or civil partnership certificate</li>
				<li>Council tax bill or recent utility bill</li>
			</ul>
			<p>We also recommend that the person registering the death brings a document that shows their own name and address, such as a driving licence.</p>
			<p>You do not have to bring any of these documents to the appointment, but it helps us to avoid any errors.</p>
			<p>For a full list of the information you′ll need to provide please visit <a href="https://www.norfolk.gov.uk/article/42548/Register-a-death" target="_blank" rel="noopener noreferrer">Register a death - Norfolk County Council<span class="govuk-visually-hidden"> (opens in new tab)</span></a>.</p>
			<p>You will be asked to check the information before the registration is completed. Once the registration has been completed, there may be a charge to correct any errors.</p>

			<h2>Documents and certificates produced by the registering district</h2>
			<p>After your appointment:</p>
			<ul>
				<li>We are not able to produce any certificates or funeral paperwork</li>
				<li>We will email your signed declaration to the register office in the district where the death took place</li>
				<li>The register office in the district where the death took place will then register the death and issue paperwork for the funeral director</li>
				<li>Certificates are £12.50 each and your payment will need to be made to the register office in the district where the death took place</li>
				<li>You can find the contact details for the register office where the death took place by visiting <a href="https://www.gov.uk/register-offices" target="_blank" rel="noopener noreferrer">Find a register office - GOV.UK<span class="govuk-visually-hidden"> (opens in new tab)</span></a></li>
			</ul>
			<p>If you want to use the free <a href="https://www.gov.uk/after-a-death/organisations-you-need-to-contact-and-tell-us-once" target="_blank" rel="noopener noreferrer">Tell Us Once<span class="govuk-visually-hidden"> (opens in new tab)</span></a> service:</p>
			<ul>
				<li>You will be given a unique reference number at the appointment.</li>
				<li>You can then use this number, after the appointment, to complete Tell Us Once online or by phone.</li>
				<li>The registrar will explain how Tell Us Once works at the appointment.</li>
			</ul>

			<h2>Cancellations or rearranging your appointment</h2>
			<p>If you need to cancel or reschedule before the day of your appointment, please use the unique link in your confirmation email.</p>
			<h2>On the day of the appointment</h2>
			<p>If you need to cancel or rearrange on the day of your appointment, please contact us on 01603 306149.</p>
			<p>If you have an appointment on a Saturday which you need to cancel or rearrange on the day, please email <a href="mailto:cancelappointment&#64;norfolk.gov.uk">cancelappointment&#64;norfolk.gov.uk</a>.</p>

			} @else if (selectedService.global_id === 48415) {
						<p>
	For your reference, the following confirmation has been sent to the main contact email address you provided.
</p>

<p>
	This confirms that you have booked an appointment to give notice of marriage or civil partnership on:<br>
	{{
	selectedSlot?.start
	| date : 'EEEE d MMMM yyyy' : '' : translateService.currentLang
	}}
	at {{ selectedSlot?.displayTime }}
</p>
@if (datastoreService?.booking?.resource_name.includes('(AC)')) {
<p>At: County Hall (Archive Centre)<br>Martineau Lane<br>Norwich<br>NR1 2DQ</p>
} @else if (datastoreService?.booking?.resource_name.includes('(CH)')) {
<p>At: County Hall<br>Martineau Lane<br>Norwich<br>NR1 2DQ</p>
} @else {
<p>At: {{ selectedLocation.name }}</p>
<ng-container *ngTemplateOutlet="locationAddress"></ng-container>
}

<h2>Please read the important information below</h2>
<p>
	For details of the Registration Office, including a map, please visit
	<a href="https://www.norfolk.gov.uk/article/42539/Registration-offices-in-Norfolk"
		target="_blank">Registration offices in Norfolk - Norfolk County Council<span
			class="govuk-visually-hidden"> (opens in new tab)</span></a>
</p>
<p>
	Please make sure you arrive on time for your appointment. If you arrive late, we may not be able to keep your
	appointment, and you will have to rearrange. Thank you for understanding.
</p>
<p>No pets are allowed but assistance dogs are very welcome.</p>

<p>
	Your Notice is venue-specific. You will need to know the full name and address of your ceremony venue before
	your notice appointment.
</p>

<p>
	Giving notice is not the same as booking the venue. If you have not booked the venue, or registrars to attend
	your ceremony, please do so.
</p>

<h2>Documents to bring</h2>
<p>
	You and your partner must bring certain original documents (not photocopies) to your notice appointment, as
	required by law.
</p>
<p>
	If you don't bring the right documents, we won't be able to take your notice, so please take the time to check
	what you need and gather everything in advance.
</p>
<p>
	<a href="https://www.norfolk.gov.uk/article/76740/Documents-to-bring-when-giving-notice"
		target="_blank" rel="noopener noreferrer">Check what documents to bring when giving notice<span
			class="govuk-visually-hidden"> (opens in new tab)</span></a>
</p>

<h2>Payment</h2>
<p>
	The standard notice fee is £46.50 per person, you will need to pay at your appointment.
</p>
<p>Additional fees may apply in certain circumstances:</p>
<ul>
	<li>
		<strong>Home Office Referral:</strong> If either of you needs to be referred to the Home Office, there is an
		additional fee of £16.50 each, which you will pay at your appointment which you attend together. If this
		applies to you, or if you or your partner have marriage visas, you will both need to bring printed
		passport-sized photographs. To find out if you will be subject to a Home Office referral, or you need passport
		photos, please visit
		<a href="https://www.norfolk.gov.uk/article/76740/Documents-to-bring-when-giving-notice"
			target="_blank" rel="noopener noreferrer">Documents to bring when giving notice - Norfolk County
			Council<span class="govuk-visually-hidden"> (opens in new tab)</span></a>.
	</li>
	<li>
		<strong>Foreign Divorce Documents:</strong> If either of you was divorced outside the British Isles, you'll
		need to pay a non-refundable fee for checking the foreign divorce paperwork. The fee is charged per divorce
		rather than per couple. The fees are:
		<ul>
			<li>£55 if the documents can be checked locally</li>
			<li>£83 if the documents need to be referred to the General Register Office (GRO)</li>
			<li>
				You can find more details about what documents to bring and how much you may need to pay by visiting
				<a href="https://www.norfolk.gov.uk/article/76740/Documents-to-bring-when-giving-notice"
					target="_blank" rel="noopener noreferrer">Documents to bring when giving notice - Norfolk County
					Council<span class="govuk-visually-hidden"> (opens in new tab)</span></a>
			</li>
		</ul>
	</li>
</ul>
<p>
	Any additional fees will be taken at your appointment. We only accept debit/credit cards and smart device
	contactless payments. We do not accept payments from American Express.
</p>

<h2>Cancelling or rearranging your appointment</h2>
<h3>Before the day of the appointment</h3>
<p>
	If you need to cancel or rearrange before the day of your appointment, please use the unique link in your
	confirmation email.
</p>

<p>
  The link lets you change the time or date of your appointment within the same office. If you wish to rearrange your appointment to a different office location, please contact us on 01603 306149. Any pre-paid certificates will transfer to your new booking.
</p>

<h3>On the day of the appointment</h3>
<p>
	If you need to cancel or rearrange on the day of your appointment, please contact us on 01603 306149.
</p>
<p>
	If you have a Saturday appointment which you need to cancel on the day, please email
	<a href="mailto:cancelappointment&#64;norfolk.gov.uk">cancelappointment&#64;norfolk.gov.uk</a>.
</p>
<p>Kind regards</p>
			} @else {
			<div class="govuk-grid-row">
				<div class="govuk-grid-column-full">
					<div class="govuk-summary-card">
						<div class="govuk-summary-card__title-wrapper">
							<h2 class="govuk-summary-card__title">
								{{ 'COMMON.BOOKING' | translate }}
							</h2>
						</div>

						<div class="govuk-summary-card__content">
							<dl class="govuk-summary-list">
								<div class="govuk-summary-list__row">
									<dt class="govuk-summary-list__key">
										{{ 'COMMON.SERVICE' | translate }}
									</dt>
									<dd class="govuk-summary-list__value">
										{{ selectedService?.name }}
									</dd>
								</div>
								<div class="govuk-summary-list__row" *ngIf="selectedResourceObj?.name">
									<dt class="govuk-summary-list__key">Venue</dt>
									<dd class="govuk-summary-list__value">
										{{ selectedResourceObj?.name }}
									</dd>
								</div>
							</dl>
						</div>
					</div>

					<div class="govuk-summary-card">
						<div class="govuk-summary-card__title-wrapper">
							<h2 class="govuk-summary-card__title">
								{{ 'COMMON.DATE_TIME' | translate }}
							</h2>
						</div>
						<div class="govuk-summary-card__content">
							<dl class="govuk-summary-list">
								<div class="govuk-summary-list__row">
									<dt class="govuk-summary-list__key">
										{{ 'COMMON.DATE' | translate }}
									</dt>
									<dd class="govuk-summary-list__value">
										{{
										selectedSlot?.start
										| date
										: 'EEEE d MMMM yyyy'
										: ''
										: translateService.currentLang
										}}
									</dd>
								</div>

								<div class="govuk-summary-list__row">
									<dt class="govuk-summary-list__key">
										{{ 'COMMON.TIME' | translate }}
									</dt>
									<dd class="govuk-summary-list__value">
										{{ selectedSlot?.displayTime }}
									</dd>
								</div>

								<div class="govuk-summary-list__row">
									<dt class="govuk-summary-list__key">
										{{ 'COMMON.DURATION' | translate }}
									</dt>
									<dd class="govuk-summary-list__value">
										{{ booking.duration }} minutes
									</dd>
								</div>
							</dl>
						</div>
					</div>

					<div class="govuk-summary-card">
						<div class="govuk-summary-card__title-wrapper">
							<h2 class="govuk-summary-card__title">
								{{ 'COMMON.PATIENT_DETAILS' | translate }}
							</h2>
						</div>
						<div class="govuk-summary-card__content">
							<dl class="govuk-summary-list">
								<div class="govuk-summary-list__row">
									<dt class="govuk-summary-list__key">
										{{ 'COMMON.NAME' | translate }}
									</dt>
									<dd class="govuk-summary-list__value">
										{{ client?.first_name }} {{ client?.last_name }}
									</dd>
								</div>

								<div class="govuk-summary-list__row">
									<dt class="govuk-summary-list__key">
										{{ 'COMMON.EMAIL_ADDRESS' | translate }}
									</dt>
									<dd class="govuk-summary-list__value">
										{{ datastoreService?.booking?.email }}
									</dd>
								</div>

								<div class="govuk-summary-list__row" *ngIf="client?.mobile_number">
									<dt class="govuk-summary-list__key">
										{{ 'COMMON.MOBILE_NUMBER' | translate }}
									</dt>
									<dd class="govuk-summary-list__value">
										{{ selectedSlot?.mobile_number }}
									</dd>
								</div>

								<div class="govuk-summary-list__row" *ngIf="client?.postcode">
									<dt class="govuk-summary-list__key">
										{{ 'COMMON.POSTNAME' | translate }}
									</dt>
									<dd class="govuk-summary-list__value">
										{{ selectedSlot?.postcode }}
									</dd>
								</div>
							</dl>
						</div>
					</div>
				</div>
			</div>

			<div class="govuk-grid-row pb-4">
				<div class="govuk-grid-column-full">
					<ng-container *ngIf="!isAdminJourney">
						<button type="submit" class="btn btn-primary" (click)="restartJourney()">
							{{ 'CONFIRMATION.RETURN_HOME' | translate }}
						</button>
					</ng-container>
					<ng-container *ngIf="isAdminJourney">
						<p class="govuk-body">
							For agents, please refresh the browser tab to return to the start.
							<br />
							For registration team, please close the browser tab and return to
							the back-office.
						</p>
					</ng-container>
				</div>
			</div>
			}
		</div>
	</div>
</div>
